import { render, staticRenderFns } from "./add-edit-location.vue?vue&type=template&id=0c0a6e4e&"
import script from "./add-edit-location.vue?vue&type=script&lang=js&"
export * from "./add-edit-location.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-location.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports